import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

// Define the segment-related API endpoints
export const segmentApi = createApi({
  reducerPath: "segmentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
  }),
  tagTypes: ["Segments"],
  endpoints: (builder) => ({
    getSegments: builder.query({
      query: ({ projectId, filename }) => {
        // e.g. C0003.MP4 => C0003.json
        const jsonFileName = filename.split(".")[0] + ".json";
        return `segments/${projectId}/${jsonFileName}`;
      },
      providesTags: (result, error, { projectId, filename }) => [
        { type: "Segments", id: `${projectId}-${filename}` },
      ],
    }),
    addSegment: builder.mutation({
      query: ({ projectId, filename, segment }) => ({
        url: `segments/${projectId}/${filename}`,
        method: "POST",
        body: segment,
      }),
      invalidatesTags: (result, error, { projectId, filename }) => [
        { type: "Segments", id: `${projectId}-${filename}` },
      ],
    }),
    updateSegment: builder.mutation({
      query: ({ projectId, filename, segmentId, segment }) => ({
        url: `segments/${projectId}/${filename}/${segmentId}`,
        method: "PUT",
        body: segment,
      }),
      invalidatesTags: (result, error, { projectId, filename }) => [
        { type: "Segments", id: `${projectId}-${filename}` },
      ],
    }),
    deleteSegment: builder.mutation({
      query: ({ projectId, filename, segmentId }) => ({
        url: `segments/${projectId}/${filename}/${segmentId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { projectId, filename }) => [
        { type: "Segments", id: `${projectId}-${filename}` },
      ],
    }),
  }),
});

export const {
  useGetSegmentsQuery,
  useAddSegmentMutation,
  useUpdateSegmentMutation,
  useDeleteSegmentMutation,
} = segmentApi;
export default segmentApi;
